import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, Pipe, PipeTransform, PLATFORM_ID } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { assetSizes } from 'src/app/consts';
import { calcResizedUrl } from 'src/app/lib/calc-resized-url';
import { devicePixelRatio } from 'src/app/lib/device-pixel-ratio';
import { AppConfigService } from 'src/app/providers/config.service';
import { UrlAutoUpscaleService } from 'src/app/services/url-auto-upscale.service';

@Pipe({
  name: 'galleryTeaserUrl',
  pure: false,
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class GalleryTeaserUrlPipe implements PipeTransform {
  constructor(
    private config: AppConfigService,
    @Inject(PLATFORM_ID) private platformId: string,
    private urlUpscaleService: UrlAutoUpscaleService
  ) {}

  transform(gallery: GalleryDto, width: number): string {
    if (!width) width = 500; // ssr sometimes needs this

    // Increase resolution on high res displays
    if (isPlatformBrowser(this.platformId) && devicePixelRatio() >= 2) width *= 2;

    const uuid = gallery.teaser?.uuid?.split('|')[0];

    if (!uuid) return '';

    let _width = 99999;
    let index = assetSizes.length - 1;
    while (assetSizes[index - 1] >= width * 0.9) index -= 1;
    if (index < 0) index = 0;
    _width = assetSizes[index];

    const out = this.urlUpscaleService.get(uuid, _width);

    return calcResizedUrl(this.config.assetsEndpoint, uuid, `${out.width}x`);
  }
}
